import { Entity } from '@backstage/catalog-model';

const ANNOTATION_KEY = 'newscorp.com/ncu-deployment-dashboard-apps';

export function isNCUDeploymentDashboardAnnotationPresent(
  entity: Entity,
): boolean {
  return Boolean(entity.metadata.annotations?.[ANNOTATION_KEY]);
}
